import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { 
		clsx
	} from 'clsx'

	import {
		getCurrentInstance,
		provide
	} from 'vue'

	
	const __default__ = { name: 'VSwitchField' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		className: {
			type: String,
			default: ""
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

const props = __props;

	

	provide('fieldDisabled', props.disabled)

	const controlId = 'control-' + getCurrentInstance()?.uid
	provide('controlId', controlId)

	const labelId = 'label-' + getCurrentInstance()?.uid
	provide('labelId', labelId)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-slot": "field",
    class: _normalizeClass(_unref(clsx)(
			__props.className,
			// Base layout
			'grid grid-cols-[1fr_auto] items-center gap-x-8 gap-y-1 sm:grid-cols-[1fr_auto]',
			// Control layout
			'[&>[data-slot=control]]:col-start-2 [&>[data-slot=control]]:self-center',
			// Label layout
			'[&>[data-slot=label]]:col-start-1 [&>[data-slot=label]]:row-start-1 [&>[data-slot=label]]:justify-self-start',
			// Description layout
			'[&>[data-slot=description]]:col-start-1 [&>[data-slot=description]]:row-start-2',
			// With description
			'[&_[data-slot=label]]:has-[[data-slot=description]]:font-medium',
			
		))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})